import { useReturnOrder } from "@/hooks/use-return-order";
import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { moment } from "@msuite/utils/date";
import { getReturnOrderNumberString } from "@msuite/utils/stock";

/** Props Interface */
interface ReturnOrderHeaderProps {
	returnOrderId: string;
}

export function ReturnOrderHeader({ returnOrderId }: ReturnOrderHeaderProps) {
	/** Query */
	const { returnOrder } = useReturnOrder(returnOrderId);

	/** Guard */
	if (!returnOrder) return null;

	/** Render */
	return (
		<ContentCard
			icon={icon("ChartNoAxesCombined")}
			title={getReturnOrderNumberString(returnOrder.number)}
			identifier={returnOrder.id}
		>
			<p>{moment(returnOrder.createdAt).longFormat()}</p>
		</ContentCard>
	);
}
